import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NameDto } from 'api/Common/Types'

export interface AffiliateState {
  types: NameDto[]
  countries: NameDto[]
}

const initialState: AffiliateState = {
  types: [],
  countries: [],
}

export const affiliateSlice = createSlice({
  name: 'affiliates',
  initialState,
  reducers: {
    setAffiliateTypes: (state: AffiliateState, action: PayloadAction<NameDto[]>) => {
      state.types = action.payload
    },
    setAffiliateCountries: (state: AffiliateState, action: PayloadAction<NameDto[]>) => {
      state.countries = action.payload
    },
  },
})
